export const baseTableConfig = [
  {
    name: "cabang",
    label: "Cabang",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "200px", minWidth: "200px" },
      }),
    },
  },
  {
    name: "totalProspek",
    label: "Total Prospek",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center"  },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export const tableConfigReasonDrop = [
  {
    name: "cabang",
    label: "Cabang",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "200px", minWidth: "200px" },
      }),
    },
  },
  {
    name: "totalDrop",
    label: "Total Prospek DROP",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
];
